import { User } from '@interfaces/user';
import { jwtDecode } from 'jwt-decode';
import * as _ from 'lodash-es';

import { AbilitySitePermissions } from '../interfaces/api/auth/ability-site-permissions.interface';

export class CastMember implements User {
    // directoryAttributes
    defaultSiteName: string;
    hubId: string;
    name: string;
    firstName: string;
    lastName: string;
    nameAbbv: string;
    nickName: string;
    preferredLanguageTypeId: string;
    username: string;

    // userProfile
    permissions: AbilitySitePermissions;
    userProfile: any;
    roles: string[];

    // token
    decodedToken: any;

    // configured sites
    sites: string[];

    constructor(data: any) {
        this.decodedToken = jwtDecode(data.token);

        if (data.directoryAttributes == null) {
            this.hubId = this.decodedToken.sub;
            this.firstName = this.decodedToken.givenName;
            this.lastName = this.decodedToken.familyName;
            this.nickName = this.decodedToken?.nickName || this.firstName;
        } else {
            this.hubId = data.directoryAttributes.sub;
            this.firstName = data.directoryAttributes.givenName;
            this.lastName = data.directoryAttributes.familyName;
            this.nickName = data.directoryAttributes.givenName;
        }

        /* istanbul ignore else */
        if (data != null) {
            this.nameAbbv = '';
            this.name = '';

            if (this.firstName != null && this.lastName != null && this.nickName != null) {
                this.nameAbbv = this.nickName.substring(0, 1) + this.lastName.substring(0, 1);
                this.name = this.nickName + ' ' + this.lastName;
            }

            /* istanbul ignore next */
            this.permissions = this.decodedToken.permissions || {} as any;
            /* istanbul ignore next */
            this.preferredLanguageTypeId = data.userProfile.preferredLanguageTypeId || 0;
            /* istanbul ignore next */
            this.roles = data.roles || this.decodedToken.rolesName || [];
            /* istanbul ignore next */
            this.userProfile = data.userProfile || {};
            /* istanbul ignore next */
            this.sites = Object.keys(this.decodedToken.sitesMap);
        }
    }
}
